import { DisplayMoney, DisplayMoneyProps } from '@tock/money';

const ConsumerDisplayMoney = ({ amount, ...rest }: DisplayMoneyProps) => {
  return <DisplayMoney amount={amount} {...rest} />;
};

export default ConsumerDisplayMoney;
